import { useState } from 'react'

import { useQuery } from '@apollo/client';

import { FETCH_COOKING_HISTORY_SESSION_BY_ID } from '../../app/graphql/queries';
import { RecipeHistorySessionData } from './useCookingHistoryEdit.types';

const useCookingHistoryEdit = ({ sessionId, onCompleted, onError }: { sessionId: string, onCompleted: (sessionData: RecipeHistorySessionData) => void, onError: (err: unknown) => void }) => {
    const [sessionData, setSessionData] = useState<RecipeHistorySessionData | null>(null);
    const { loading } = useQuery(FETCH_COOKING_HISTORY_SESSION_BY_ID, {
        skip: !sessionId,
        variables: {
            sessionID: sessionId
        },
        onCompleted: (data) => {
            onCompleted(data.Sessions_DB_by_pk)
            setSessionData(data.Sessions_DB_by_pk)
            // handle userId check, if userId does not match redirect user to cooking history page, since user cannot edit just any sessionId
        },
        onError: (err) => {
            onError(err)
        }
    })
    return { sessionData, loading };
}

export default useCookingHistoryEdit